// See section 5.2 of the MRAID 3.0 spec at
// https://www.iab.com/wp-content/uploads/2017/07/MRAID_3.0_FINAL.pdf.
export const MRAID_EVENT_READY = "ready";
export const MRAID_EVENT_ERROR = "error";
export const MRAID_EVENT_STATE_CHANGE = "stateChange";
export const MRAID_EVENT_EXPOSURE_CHANGE = "exposureChange";
export const MRAID_EVENT_VIEWABLE_CHANGE = "viewableChange";
export const MRAID_EVENT_SIZE_CHANGE = "sizeChange";
export const MRAID_STATE_CHANGE_EVENTS = [
  MRAID_EVENT_READY,
  MRAID_EVENT_STATE_CHANGE,
  MRAID_EVENT_EXPOSURE_CHANGE,
  MRAID_EVENT_VIEWABLE_CHANGE,
  MRAID_EVENT_SIZE_CHANGE,
];
export const ALL_MRAID_EVENTS = [
  ...MRAID_STATE_CHANGE_EVENTS,
  MRAID_EVENT_ERROR,
];

// See section 6.2;
export const PLACEMENT_TYPE_INTERSTITIAL = "interstitial";
export const PLACEMENT_TYPE_INLINE = "inline";

// See section 6.4;
export const MRAID_ORIENTATION_PORTRAIT = "portrait";
export const MRAID_ORIENTATION_LANDSCAPE = "landscape";

export const MRAID_STATE_LOADING = "loading";
export const MRAID_STATE_DEFAULT = "default";



// WEBPACK FOOTER //
// ./src/js/madlib/csp-env/mraid_constants.js